import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const LocationMap = lazy(() => import(/* webpackChunkName: "LocationMap" */ './components/LocationMap'));

const locationMap = document.getElementById('location-map');
if (locationMap != null) {
    const props = parseDatasetToProps(locationMap.dataset);

    render(
        <Suspense fallback={<></>}>
            <LocationMap
                {...props}
            />
        </Suspense>,
        locationMap
    );
}
